module.exports = "<div class=\"frontpage-splash\">\n    <h1>Nick Smith Consulting</h1>\n    <h2>High level consultancy, creative training</h2>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/pages/frontpage/frontpage.component.html
// module id = ../../../../../src/app/pages/frontpage/frontpage.component.html
// module chunks = 0